import { render, staticRenderFns } from "./MatchingCustomerFeedback.vue?vue&type=template&id=2ec0cf5e&lang=pug"
import script from "./MatchingCustomerFeedback.vue?vue&type=script&lang=js"
export * from "./MatchingCustomerFeedback.vue?vue&type=script&lang=js"
import style0 from "./MatchingCustomerFeedback.vue?vue&type=style&index=0&id=2ec0cf5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports